import { apiClient } from "@/ultis/apiClient";
//const controller = "wing-telecom";
const controller = "wing-metfone-esim";
const isTest = false;

/**
 * Dev: set VUE_APP_HARDCODE_CHECK_MATCH_INFO_CHANGE_SIM=true to force this body on
 * metfoneServices/checkMatchInfoChangeSim.
 */
const HARDCODE_CHECK_MATCH_INFO_CHANGE_SIM = {
  token: "UcPpVZOIxJb4Z/uEFMakFUgUUxcejUVGjfVK3NQ6rs4=",
  locale: "en_US",
  accountABA: "720784",
  isdn: "716657808",
  idType: 1,
  idNumber: "010917954",
  fullName: "KEO PHANNAN",
  dob: "03/04/1986",
};

const mockIdCardReaderV2EsimABAResponse = () => ({
  code: "200",
  message: "Success",
  data: {
    errorCode: 0,
    errorDecription: "Success (bypass idCardReaderV2EsimABA)",
    partner: "BLUETECH",
    transid: `${Date.now()}`,
    idCardInfo: {
      idNumber: "010917954",
      name: "KEO PHANNAN",
      enSex: "Male",
      khSex: "ប្រុស",
      enDob: "03/04/1986",
      khDob: "03/04/1986",
      enProvince: "Phnom Penh",
      khProvince: "ភ្នំពេញ",
      isFraud: "false",
      pathImage: "/mock/path-front.jpg",
    },
  },
});

const mockFaceMatchEsimV2Response = () => ({
  code: "200",
  message: "Success",
  data: {
    errorCode: 0,
    errorDecription: "Success (bypass faceMatchV2EsimABA)",
    face: {
      isFraud: "false",
      match: "true",
    },
  },
});

export const actions = {
  // get-list-support-device
  async getListSupportDevice({ commit }, params) {
    return apiClient.post(controller + "/get-list-support-device", params);
  },

  //search-isdn
  async searchIsdn({ commit }, params) {
    return apiClient.post(controller + "/search-isdn", params);
  },

  async getRecommendIsdn({ commit }, params) {
    return apiClient.post(controller + "/get-recommend-isdn", params);
  },

  //get-telecom-package
  async getTelecomPackage({ commit }, params) {
    return apiClient.post(controller + "/get-telecom-package", params);
  },

  //check-limit-buy-sim
  async checkLimitBuySim({ commit }, params) {
    return apiClient.post(controller + "/check-limit-buy-sim", params);
  },

  async prePayment({ commit }, params) {
    return apiClient.post(controller + "/pre-payment", params);
  },

  async idCardReaderV2EsimABA({ commit }, params) { 
    return apiClient.postV2("wing-metfone-ekyc/scan-id-card", params);
  },

  async faceMatchV2EsimABA({ commit }, params) { 
    return apiClient.postV2("wing-metfone-ekyc/scan-face-match", params);
  },

  async getHistories({ commit }, params) {
    return apiClient.post(controller + "/get-histories", params);
  },

  //=============================================================================

  async getListOrderEsimABA({ commit }, params) {
    return apiClient.post(controller + "/getListOrderEsimABA", params);
  },

  async buyEsimABA({ commit }, params) {
    return apiClient.post(controller + "/buyEsimABA", params);
  },

  async checkPaymentStatus({ commit }, params) {
    // Dev only: set VUE_APP_BYPASS_CHECK_PAYMENT_STATUS_ABA=true to skip poll.
    if (process.env.VUE_APP_BYPASS_CHECK_PAYMENT_STATUS_ABA === "true") {
      return {
        code: "200",
        message: "Success",
        data: {
          errorCode: 0,
          checkStatusResponseDTO: {
            state: 5000,
            paymentReference:
              process.env.VUE_APP_BYPASS_PAYMENT_REFERENCE || "17746498288990",
            paymentStatus: "SUCCESS",
          },
        },
      };
    }
    return apiClient.post(controller + "/checkPaymentStatusABA", params);
  },

  async passportReaderV2EsimABA({ commit }, params) {
    return apiClient.post(controller + "/passportReaderV2EsimABA", params);
  },

  async mascomFaceMatchV2EsimABA({ commit }, params) {
    if (process.env.VUE_APP_BYPASS_FACE_MATCH_ESIM_V2 === "true") {
      return mockFaceMatchEsimV2Response();
    }
    return apiClient.postV2(controller + "/mascomFaceMatchV2EsimABA", params);
  },

  async checkChangeSimIsdn({ commit }, params) {
    return apiClient.post(controller + "/checkChangeSimIsdn", params);
  },

  async checkMatchInfoChangeSim({ commit }, params) {
    const payload =
      process.env.VUE_APP_HARDCODE_CHECK_MATCH_INFO_CHANGE_SIM === "true"
        ? { ...HARDCODE_CHECK_MATCH_INFO_CHANGE_SIM }
        : params;

    const bypass =
      process.env.VUE_APP_BYPASS_CHECK_MATCH_INFO_CHANGE_SIM === "true";
    const mockResponse = () => ({
      code: "200",
      message: "Success",
      data: {
        errorCode: 0,
        message: "Success (bypass checkMatchInfoChangeSim)",
        orderCode: process.env.VUE_APP_BYPASS_CHECK_MATCH_ORDER_CODE || "",
      },
    });

    if (!bypass) {
      return apiClient.post(controller + "/checkMatchInfoChangeSim", payload);
    }

    // Bypass: UI uses mock; can still keep network call for debugging if needed.
    if (
      process.env.VUE_APP_BYPASS_CHECK_MATCH_INFO_CHANGE_SIM_SKIP_NETWORK !==
      "true"
    ) {
      try {
        await apiClient.post(controller + "/checkMatchInfoChangeSim", payload);
      } catch (_) {
        /* ignore network error when bypassing */
      }
    }
    return mockResponse();
  },

  async prePaymentChangeSim({ commit }, params) {
    return apiClient.post(controller + "/prePaymentChangeSim", params);
  },

  async paymentChangeSim({ commit }, params) {
    return apiClient.post(controller + "/paymentChangeSim", params);
  },
};
